module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Логин или email":"Username or e-mail","Пароль":"Password","Авторизация":"Authorization","Регистрация":"Registration"}}')
  delete Component.options._Ctor
}
